import React, { useEffect } from "react";
import Layout from "../../layout/Layout";
import CustomTab from "../../components/CustomTab";
import { QuickLinksProvider } from "../../context/QuickLinksContext";
import { useDispatch } from "react-redux";
import { getAllNotifications } from "../../redux/actions/notifications.dispatcher";

const Dashboard = () => {
  const dispatch = useDispatch();

  // Fetch on mount, then poll so new notifications (e.g. a profile-change verdict)
  // show in the bell without a manual page reload. Also refetch when the tab
  // regains focus.
  useEffect(() => {
    dispatch(getAllNotifications());
    const interval = setInterval(() => dispatch(getAllNotifications()), 60000);
    const onFocus = () => dispatch(getAllNotifications());
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", onFocus);
    };
  }, [dispatch]);

  return (
    <QuickLinksProvider>
      <Layout>
        <CustomTab />
      </Layout>
    </QuickLinksProvider>
  );
};

export default Dashboard;
